import { FC, useCallback } from 'react';

import { AccountLinkField, useAccountLink } from 'pages/admin/customers/edit/account-link';
import { formatCustomer } from 'utils/format';

interface Props {
  customerId: number;
  onSaved: (code: number | null) => void;
  onCancel: () => void;
}

/*
 * The account's fleet link, edited in a dialog from the Fleet Files grid. Same state and field as the
 * customer-details page (`account-link.tsx`); on a committed save the page refreshes the grid, and a
 * failure keeps the dialog open with the selection and the reason (F09).
 */
export const AccountLinkForm: FC<Props> = ({ customerId, onSaved, onCancel }) => {
  const link = useAccountLink(customerId);

  const save = useCallback(async () => {
    if (await link.save()) onSaved(link.selectedCode);
  }, [link, onSaved]);

  return (
    <div className="dialog-body" data-testid="account-link-form">
      <h3>{link.customer ? formatCustomer(link.customer) : 'Loading…'}</h3>
      <p className="text-dark margin-top-8px">Fleet file account</p>
      <AccountLinkField link={link} />
      <div className="d-flex justify-content-between margin-top-16px">
        <button type="button" className="btn-outline" onClick={onCancel} disabled={link.saving}>
          Cancel
        </button>
        <button type="button" className="btn-primary" disabled={link.saving || !link.locationId} onClick={save}>
          <span>{link.saving ? 'Saving…' : 'Save'}</span>
        </button>
      </div>
    </div>
  );
};
